/*
 * @Description:
 * @Author: luckymiaow
 * @Date: 2022-05-05 16:56:39
 * @LastEditors: luckymiaow
 */

// import camelCase from 'lodash-es/camelCase';
import { camelCase } from 'lodash-es';
import type { Ref } from 'vue';
import { computed, inject, provide } from 'vue';

// 注入key
export const key = Symbol('provideConfig');

export default () => {
  const provideConfig = (props: any) => {
    provide(key, props);
  };

  /**
   * @description: 注入配置,需要注入的配置需要编写CConfigProvider组件的props
   * @param {*}
   * @return {*}
   * @author: luckymiaow
   */
  // const injectConfig = <T extends object>(componentName: string, props?: T): T => {
  //   const config = inject(key, {}) as T;
  //   const name = camelCase(componentName);
  //   const result = config && name in config ? config[name] ?? {} : {};
  //   if (props == null) return result;
  //   for (let key in props) {
  //     if (key in props && props[key] !== undefined) {
  //       result[key] = props[key];
  //     }
  //   }
  //   return result;
  // };

  const injectConfig = <T extends object>(componentName: string, props?: T): Ref<T> | undefined => {
    const config: any = inject(key, {}) as T;
    const name: any = camelCase(componentName);

    const result = computed(() => {
      const res = {} as any;
      if (config.value && name in config.value) {
        // eslint-disable-next-line guard-for-in
        for (let key1 in config.value[name]) {
          res[key1] = config.value[name][key1];
        }
      }
      if (props) {
        for (let key1 in props) {
          if (key1 in props && props[key1] !== undefined) {
            res[key1] = props[key1];
          }
        }
      }
      return res;
    });

    return result;
  };
  return { provideConfig, injectConfig };
};
